import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dreamy%20soft%20pastel%20pink%20and%20cream%20gradient%20background%20with%20floating%20cherry%20blossom%20petals%2C%20ethereal%20Japanese%20spring%20atmosphere%2C%20subtle%20light%20rays%2C%20clean%20minimal%20composition%2C%20anime%20inspired%20aesthetic%2C%20delicate%20feminine%20design&width=1600&height=900&seq=yuri-hero-bg&orientation=landscape"
          alt="百合会"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
          <div className="w-5 h-5 rounded-full bg-primary-500 flex items-center justify-center">
            <i className="ri-flower-line text-xs text-background-50"></i>
          </div>
          <span className="text-sm text-background-50/90 font-medium">中国最大的百合文化爱好者社区</span>
        </div>

        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 leading-tight">
          加入百合会，发现
          <br />
          <span className="text-primary-300">女女情感故事</span>
          的无限魅力
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          百合会是专为百合文化爱好者打造的核心聚集地，汇聚百合漫画、百合动漫、百合小说等优质内容。
          与志同道合的伙伴一起探索百合作品的魅力，发现最新推荐与活动资讯。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/manga"
            className="px-8 py-3 rounded-full text-base font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            探索百合作品
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full text-base font-medium border border-background-50/30 text-background-50 hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            了解百合会
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-background-50/30 flex items-start justify-center p-1.5">
          <div className="w-1.5 h-3 bg-background-50/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}